// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/trajectory_controller_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata1 } from "../google/protobuf/empty";
import { Pose, protoMetadata as protoMetadata2, Quaternion, Vector3 } from "./geometry";
import { JointTrajectory, protoMetadata as protoMetadata3 } from "./joints";

export const protobufPackage = "trajectorycontroller";

export enum TCState {
  TC_IDLE = 0,
  TC_EXECUTING = 1,
  TC_STOPPING = 2,
  TC_ERROR = 3,
  UNRECOGNIZED = -1,
}

export function tCStateFromJSON(object: any): TCState {
  switch (object) {
    case 0:
    case "TC_IDLE":
      return TCState.TC_IDLE;
    case 1:
    case "TC_EXECUTING":
      return TCState.TC_EXECUTING;
    case 2:
    case "TC_STOPPING":
      return TCState.TC_STOPPING;
    case 3:
    case "TC_ERROR":
      return TCState.TC_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TCState.UNRECOGNIZED;
  }
}

export function tCStateToJSON(object: TCState): string {
  switch (object) {
    case TCState.TC_IDLE:
      return "TC_IDLE";
    case TCState.TC_EXECUTING:
      return "TC_EXECUTING";
    case TCState.TC_STOPPING:
      return "TC_STOPPING";
    case TCState.TC_ERROR:
      return "TC_ERROR";
    case TCState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TCErrorCode {
  TC_ERROR_NONE = 0,
  TC_ERROR_IN_SINGULARITY = 1,
  TC_ERROR_TRAJECTORY_OVER_LIMITS = 2,
  TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS = 3,
  TC_ERROR_STALENESS_TIMEOUT = 4,
  TC_ERROR_INVALID_TRAJECTORY = 5,
  TC_ERROR_COMPUTATION = 6,
  TC_ERROR_WORKSPACE_LIMIT_VIOLATION = 7,
  TC_ERROR_OVERRUN = 8,
  TC_ERROR_QUEUE_FULL = 9,
  TC_ERROR_NO_CONTROL = 10,
  TC_ERROR_NOT_READY = 11,
  /** TC_ERROR_NOT_IDLE - setter rejected because TC not IDLE */
  TC_ERROR_NOT_IDLE = 12,
  /** TC_ERROR_INVALID_ARGUMENT - out-of-range / wrong length / NaN */
  TC_ERROR_INVALID_ARGUMENT = 13,
  /** TC_ERROR_FRAME_NOT_SPECIFIED - SpeedL frame-slot validation (commanded_frame / reference / velocity_expressed_in). */
  TC_ERROR_FRAME_NOT_SPECIFIED = 14,
  /** TC_ERROR_FRAME_NOT_SUPPORTED - parent frame not supported (e.g. CAMERA commanded_frame, */
  TC_ERROR_FRAME_NOT_SUPPORTED = 15,
  /** TC_ERROR_INCOMPATIBLE_FRAMES - FLANGE velocity axes) */
  TC_ERROR_INCOMPATIBLE_FRAMES = 16,
  UNRECOGNIZED = -1,
}

export function tCErrorCodeFromJSON(object: any): TCErrorCode {
  switch (object) {
    case 0:
    case "TC_ERROR_NONE":
      return TCErrorCode.TC_ERROR_NONE;
    case 1:
    case "TC_ERROR_IN_SINGULARITY":
      return TCErrorCode.TC_ERROR_IN_SINGULARITY;
    case 2:
    case "TC_ERROR_TRAJECTORY_OVER_LIMITS":
      return TCErrorCode.TC_ERROR_TRAJECTORY_OVER_LIMITS;
    case 3:
    case "TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS":
      return TCErrorCode.TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS;
    case 4:
    case "TC_ERROR_STALENESS_TIMEOUT":
      return TCErrorCode.TC_ERROR_STALENESS_TIMEOUT;
    case 5:
    case "TC_ERROR_INVALID_TRAJECTORY":
      return TCErrorCode.TC_ERROR_INVALID_TRAJECTORY;
    case 6:
    case "TC_ERROR_COMPUTATION":
      return TCErrorCode.TC_ERROR_COMPUTATION;
    case 7:
    case "TC_ERROR_WORKSPACE_LIMIT_VIOLATION":
      return TCErrorCode.TC_ERROR_WORKSPACE_LIMIT_VIOLATION;
    case 8:
    case "TC_ERROR_OVERRUN":
      return TCErrorCode.TC_ERROR_OVERRUN;
    case 9:
    case "TC_ERROR_QUEUE_FULL":
      return TCErrorCode.TC_ERROR_QUEUE_FULL;
    case 10:
    case "TC_ERROR_NO_CONTROL":
      return TCErrorCode.TC_ERROR_NO_CONTROL;
    case 11:
    case "TC_ERROR_NOT_READY":
      return TCErrorCode.TC_ERROR_NOT_READY;
    case 12:
    case "TC_ERROR_NOT_IDLE":
      return TCErrorCode.TC_ERROR_NOT_IDLE;
    case 13:
    case "TC_ERROR_INVALID_ARGUMENT":
      return TCErrorCode.TC_ERROR_INVALID_ARGUMENT;
    case 14:
    case "TC_ERROR_FRAME_NOT_SPECIFIED":
      return TCErrorCode.TC_ERROR_FRAME_NOT_SPECIFIED;
    case 15:
    case "TC_ERROR_FRAME_NOT_SUPPORTED":
      return TCErrorCode.TC_ERROR_FRAME_NOT_SUPPORTED;
    case 16:
    case "TC_ERROR_INCOMPATIBLE_FRAMES":
      return TCErrorCode.TC_ERROR_INCOMPATIBLE_FRAMES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TCErrorCode.UNRECOGNIZED;
  }
}

export function tCErrorCodeToJSON(object: TCErrorCode): string {
  switch (object) {
    case TCErrorCode.TC_ERROR_NONE:
      return "TC_ERROR_NONE";
    case TCErrorCode.TC_ERROR_IN_SINGULARITY:
      return "TC_ERROR_IN_SINGULARITY";
    case TCErrorCode.TC_ERROR_TRAJECTORY_OVER_LIMITS:
      return "TC_ERROR_TRAJECTORY_OVER_LIMITS";
    case TCErrorCode.TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS:
      return "TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS";
    case TCErrorCode.TC_ERROR_STALENESS_TIMEOUT:
      return "TC_ERROR_STALENESS_TIMEOUT";
    case TCErrorCode.TC_ERROR_INVALID_TRAJECTORY:
      return "TC_ERROR_INVALID_TRAJECTORY";
    case TCErrorCode.TC_ERROR_COMPUTATION:
      return "TC_ERROR_COMPUTATION";
    case TCErrorCode.TC_ERROR_WORKSPACE_LIMIT_VIOLATION:
      return "TC_ERROR_WORKSPACE_LIMIT_VIOLATION";
    case TCErrorCode.TC_ERROR_OVERRUN:
      return "TC_ERROR_OVERRUN";
    case TCErrorCode.TC_ERROR_QUEUE_FULL:
      return "TC_ERROR_QUEUE_FULL";
    case TCErrorCode.TC_ERROR_NO_CONTROL:
      return "TC_ERROR_NO_CONTROL";
    case TCErrorCode.TC_ERROR_NOT_READY:
      return "TC_ERROR_NOT_READY";
    case TCErrorCode.TC_ERROR_NOT_IDLE:
      return "TC_ERROR_NOT_IDLE";
    case TCErrorCode.TC_ERROR_INVALID_ARGUMENT:
      return "TC_ERROR_INVALID_ARGUMENT";
    case TCErrorCode.TC_ERROR_FRAME_NOT_SPECIFIED:
      return "TC_ERROR_FRAME_NOT_SPECIFIED";
    case TCErrorCode.TC_ERROR_FRAME_NOT_SUPPORTED:
      return "TC_ERROR_FRAME_NOT_SUPPORTED";
    case TCErrorCode.TC_ERROR_INCOMPATIBLE_FRAMES:
      return "TC_ERROR_INCOMPATIBLE_FRAMES";
    case TCErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PrimitiveEventType {
  PRIMITIVE_EVENT_UNSPECIFIED = 0,
  /** PRIMITIVE_STARTED - Primitive began executing. */
  PRIMITIVE_STARTED = 1,
  /** PRIMITIVE_COMPLETE - Primitive finished naturally (isComplete() returned true). */
  PRIMITIVE_COMPLETE = 2,
  /** PRIMITIVE_STOPPED - Primitive was interrupted by Stop/FastStop before completing. */
  PRIMITIVE_STOPPED = 3,
  /** PRIMITIVE_FAILED - Primitive encountered an error (see error field). */
  PRIMITIVE_FAILED = 4,
  /** PRIMITIVE_QUEUE_CLEARED - ClearQueue was called; pending primitives were discarded. */
  PRIMITIVE_QUEUE_CLEARED = 5,
  UNRECOGNIZED = -1,
}

export function primitiveEventTypeFromJSON(object: any): PrimitiveEventType {
  switch (object) {
    case 0:
    case "PRIMITIVE_EVENT_UNSPECIFIED":
      return PrimitiveEventType.PRIMITIVE_EVENT_UNSPECIFIED;
    case 1:
    case "PRIMITIVE_STARTED":
      return PrimitiveEventType.PRIMITIVE_STARTED;
    case 2:
    case "PRIMITIVE_COMPLETE":
      return PrimitiveEventType.PRIMITIVE_COMPLETE;
    case 3:
    case "PRIMITIVE_STOPPED":
      return PrimitiveEventType.PRIMITIVE_STOPPED;
    case 4:
    case "PRIMITIVE_FAILED":
      return PrimitiveEventType.PRIMITIVE_FAILED;
    case 5:
    case "PRIMITIVE_QUEUE_CLEARED":
      return PrimitiveEventType.PRIMITIVE_QUEUE_CLEARED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PrimitiveEventType.UNRECOGNIZED;
  }
}

export function primitiveEventTypeToJSON(object: PrimitiveEventType): string {
  switch (object) {
    case PrimitiveEventType.PRIMITIVE_EVENT_UNSPECIFIED:
      return "PRIMITIVE_EVENT_UNSPECIFIED";
    case PrimitiveEventType.PRIMITIVE_STARTED:
      return "PRIMITIVE_STARTED";
    case PrimitiveEventType.PRIMITIVE_COMPLETE:
      return "PRIMITIVE_COMPLETE";
    case PrimitiveEventType.PRIMITIVE_STOPPED:
      return "PRIMITIVE_STOPPED";
    case PrimitiveEventType.PRIMITIVE_FAILED:
      return "PRIMITIVE_FAILED";
    case PrimitiveEventType.PRIMITIVE_QUEUE_CLEARED:
      return "PRIMITIVE_QUEUE_CLEARED";
    case PrimitiveEventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BuiltInFrame {
  BUILT_IN_FRAME_UNSPECIFIED = 0,
  BUILT_IN_FRAME_WORLD = 1,
  BUILT_IN_FRAME_BASE = 2,
  BUILT_IN_FRAME_FLANGE = 3,
  BUILT_IN_FRAME_CAMERA = 4,
  UNRECOGNIZED = -1,
}

export function builtInFrameFromJSON(object: any): BuiltInFrame {
  switch (object) {
    case 0:
    case "BUILT_IN_FRAME_UNSPECIFIED":
      return BuiltInFrame.BUILT_IN_FRAME_UNSPECIFIED;
    case 1:
    case "BUILT_IN_FRAME_WORLD":
      return BuiltInFrame.BUILT_IN_FRAME_WORLD;
    case 2:
    case "BUILT_IN_FRAME_BASE":
      return BuiltInFrame.BUILT_IN_FRAME_BASE;
    case 3:
    case "BUILT_IN_FRAME_FLANGE":
      return BuiltInFrame.BUILT_IN_FRAME_FLANGE;
    case 4:
    case "BUILT_IN_FRAME_CAMERA":
      return BuiltInFrame.BUILT_IN_FRAME_CAMERA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BuiltInFrame.UNRECOGNIZED;
  }
}

export function builtInFrameToJSON(object: BuiltInFrame): string {
  switch (object) {
    case BuiltInFrame.BUILT_IN_FRAME_UNSPECIFIED:
      return "BUILT_IN_FRAME_UNSPECIFIED";
    case BuiltInFrame.BUILT_IN_FRAME_WORLD:
      return "BUILT_IN_FRAME_WORLD";
    case BuiltInFrame.BUILT_IN_FRAME_BASE:
      return "BUILT_IN_FRAME_BASE";
    case BuiltInFrame.BUILT_IN_FRAME_FLANGE:
      return "BUILT_IN_FRAME_FLANGE";
    case BuiltInFrame.BUILT_IN_FRAME_CAMERA:
      return "BUILT_IN_FRAME_CAMERA";
    case BuiltInFrame.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Linear and angular velocity in the robot base frame.
 * Linear: meters/second.  Angular: radians/second.
 *
 * Not currently referenced by any primitive; kept for a future
 * Cartesian-velocity wire surface (e.g. status broadcast). Do not delete.
 */
export interface CartesianVelocity {
  linear: Vector3 | undefined;
  angular: Vector3 | undefined;
}

/**
 * Starts a position-streaming joint jog. Carries the stream settings and no
 * joint target: targets are supplied exclusively through
 * WriteServoJ(ServoJTarget), and the arm holds its commanded position until
 * the first one arrives.
 */
export interface ServoJ {
  /** First-order LPF gain on the streamed target. */
  kP: number;
  /** Staleness window before the stream is considered stale. */
  commandTimeoutMs: number;
  /** Smooth-start ramp from commanded position to the stream. */
  rampInDurationMs: number;
}

export interface ServoL {
  /** Target pose of the flange in the base frame. */
  targetPoseBaseToFlange: Pose | undefined;
}

/**
 * Direction-only joint jog — speed at TC comes from snapshotted
 * JogConfig × slider × active SafetyLimits, composed at enqueue time.
 * Requires SetSafetySession and SetSpeedSlider to have been pushed at
 * least once before this primitive will be accepted.
 */
export interface SpeedJ {
  direction: JointDirection | undefined;
}

/**
 * A built-in reference frame plus a rigid offset expressed in that frame.
 * Used for SpeedL's `reference` and `commanded_frame` slots; the frame in world
 * coordinates is world_to_parent · pose_in_parent.
 *
 * The offset is REQUIRED: an unset slot (default zero quaternion) is rejected
 * with TC_ERROR_FRAME_NOT_SPECIFIED, never treated as identity.
 */
export interface Frame {
  parent: BuiltInFrame;
  /** rigid offset (position + orientation) of this frame, in `parent` coordinates */
  poseInParent: Pose | undefined;
}

/**
 * A built-in reference frame plus a rotation-only offset expressed in that
 * frame. Used for SpeedL's `velocity_expressed_in` slot: it selects the axes
 * the CartesianDirection is applied along, so only orientation is meaningful
 * (no translation). Same required / fail-loud contract as Frame.
 */
export interface Orientation {
  parent: BuiltInFrame;
  /** rotation of this frame relative to `parent` */
  rotationInParent: Quaternion | undefined;
}

/**
 * Cartesian jog. `direction` is a one-hot ±1 axis; the TC sets the
 * linear/angular speed from snapshotted JogConfig × slider × SafetyLimits.
 * Same SetSafetySession + SetSpeedSlider prerequisites as SpeedJ.
 *
 * All three frame slots are REQUIRED (unset → TC_ERROR_FRAME_NOT_SPECIFIED),
 * per-command and snapshotted at enqueue:
 *   * reference:             frame the motion is actuated relative to; parent must
 *                            be world-side (WORLD/BASE). Same side as commanded_frame
 *                            → TC_ERROR_INCOMPATIBLE_FRAMES.
 *   * commanded_frame:       the controlled point (flange→TCP offset) — origin of the
 *                            rotational-jog pivot and where the TCP-linear limit binds.
 *                            parent must be FLANGE; CAMERA → TC_ERROR_FRAME_NOT_SUPPORTED.
 *   * velocity_expressed_in: rotation-only frame selecting the axes `direction` is
 *                            applied along (WORLD/BASE, identity rotation).
 */
export interface SpeedL {
  direction: CartesianDirection | undefined;
  reference: Frame | undefined;
  commandedFrame: Frame | undefined;
  velocityExpressedIn: Orientation | undefined;
}

export interface ExecuteTrajectory {
  trajectory: JointTrajectory | undefined;
}

export interface WorldToBaseUpdate {
  worldToBase: Pose | undefined;
}

export interface JointDirection {
  /** length 6 */
  entries: number[];
}

export interface CartesianDirection {
  /** length 3 */
  linear: number[];
  /** length 3 */
  angular: number[];
}

export interface Primitive {
  servoJ?: ServoJ | undefined;
  servoL?: ServoL | undefined;
  speedJ?: SpeedJ | undefined;
  speedL?: SpeedL | undefined;
  executeTrajectory?:
    | ExecuteTrajectory
    | undefined;
  /** sequenced settings command, not a motion primitive */
  worldToBaseUpdate?: WorldToBaseUpdate | undefined;
}

export interface EnqueueReply {
  accepted: boolean;
  primitiveId?: number | undefined;
  error?: TCErrorCode | undefined;
}

export interface SafetyLimits {
  /** rad/s, length 6 */
  jointVelocityMax: number[];
  /** rad/s², length 6 */
  jointAccelerationMax: number[];
  /** Nm, length 6 */
  jointTorqueMax: number[];
  /** m/s */
  tcpLinearVelocityMax: number;
}

export interface SafetySession {
  fullSpeed: SafetyLimits | undefined;
  slowSpeed: SafetyLimits | undefined;
}

export interface SpeedSlider {
  /** [0, 1] */
  value: number;
}

export interface SetReply {
  accepted: boolean;
  error?: TCErrorCode | undefined;
}

export interface ControllerStateMsg {
  state: TCState;
  activePrimitiveId?: number | undefined;
  activePrimitiveType?: string | undefined;
  queueDepth: number;
  speedScaling: number;
  paused: boolean;
  stepCount: number;
  errors: TCErrorCode[];
}

export interface PrimitiveEventMsg {
  type: PrimitiveEventType;
  primitiveId?: number | undefined;
  error?: TCErrorCode | undefined;
}

export interface ServoJTarget {
  /** Joint positions in radians. */
  targetJoints: number[];
}

export interface ServoLTarget {
  /** Target pose of the flange in the base frame. */
  targetPoseBaseToFlange: Pose | undefined;
}

function createBaseCartesianVelocity(): CartesianVelocity {
  return { linear: undefined, angular: undefined };
}

export const CartesianVelocity: MessageFns<CartesianVelocity> = {
  encode(message: CartesianVelocity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linear !== undefined) {
      Vector3.encode(message.linear, writer.uint32(10).fork()).join();
    }
    if (message.angular !== undefined) {
      Vector3.encode(message.angular, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CartesianVelocity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCartesianVelocity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linear = Vector3.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.angular = Vector3.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CartesianVelocity {
    return {
      linear: isSet(object.linear) ? Vector3.fromJSON(object.linear) : undefined,
      angular: isSet(object.angular) ? Vector3.fromJSON(object.angular) : undefined,
    };
  },

  toJSON(message: CartesianVelocity): unknown {
    const obj: any = {};
    if (message.linear !== undefined) {
      obj.linear = Vector3.toJSON(message.linear);
    }
    if (message.angular !== undefined) {
      obj.angular = Vector3.toJSON(message.angular);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CartesianVelocity>, I>>(base?: I): CartesianVelocity {
    return CartesianVelocity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CartesianVelocity>, I>>(object: I): CartesianVelocity {
    const message = createBaseCartesianVelocity();
    message.linear = (object.linear !== undefined && object.linear !== null)
      ? Vector3.fromPartial(object.linear)
      : undefined;
    message.angular = (object.angular !== undefined && object.angular !== null)
      ? Vector3.fromPartial(object.angular)
      : undefined;
    return message;
  },
};

function createBaseServoJ(): ServoJ {
  return { kP: 0, commandTimeoutMs: 0, rampInDurationMs: 0 };
}

export const ServoJ: MessageFns<ServoJ> = {
  encode(message: ServoJ, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kP !== 0) {
      writer.uint32(9).double(message.kP);
    }
    if (message.commandTimeoutMs !== 0) {
      writer.uint32(16).uint32(message.commandTimeoutMs);
    }
    if (message.rampInDurationMs !== 0) {
      writer.uint32(24).uint32(message.rampInDurationMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoJ {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoJ();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.kP = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.commandTimeoutMs = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rampInDurationMs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoJ {
    return {
      kP: isSet(object.kP) ? globalThis.Number(object.kP) : 0,
      commandTimeoutMs: isSet(object.commandTimeoutMs) ? globalThis.Number(object.commandTimeoutMs) : 0,
      rampInDurationMs: isSet(object.rampInDurationMs) ? globalThis.Number(object.rampInDurationMs) : 0,
    };
  },

  toJSON(message: ServoJ): unknown {
    const obj: any = {};
    if (message.kP !== 0) {
      obj.kP = message.kP;
    }
    if (message.commandTimeoutMs !== 0) {
      obj.commandTimeoutMs = Math.round(message.commandTimeoutMs);
    }
    if (message.rampInDurationMs !== 0) {
      obj.rampInDurationMs = Math.round(message.rampInDurationMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoJ>, I>>(base?: I): ServoJ {
    return ServoJ.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoJ>, I>>(object: I): ServoJ {
    const message = createBaseServoJ();
    message.kP = object.kP ?? 0;
    message.commandTimeoutMs = object.commandTimeoutMs ?? 0;
    message.rampInDurationMs = object.rampInDurationMs ?? 0;
    return message;
  },
};

function createBaseServoL(): ServoL {
  return { targetPoseBaseToFlange: undefined };
}

export const ServoL: MessageFns<ServoL> = {
  encode(message: ServoL, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.targetPoseBaseToFlange !== undefined) {
      Pose.encode(message.targetPoseBaseToFlange, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoL {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoL();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.targetPoseBaseToFlange = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoL {
    return {
      targetPoseBaseToFlange: isSet(object.targetPoseBaseToFlange)
        ? Pose.fromJSON(object.targetPoseBaseToFlange)
        : undefined,
    };
  },

  toJSON(message: ServoL): unknown {
    const obj: any = {};
    if (message.targetPoseBaseToFlange !== undefined) {
      obj.targetPoseBaseToFlange = Pose.toJSON(message.targetPoseBaseToFlange);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoL>, I>>(base?: I): ServoL {
    return ServoL.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoL>, I>>(object: I): ServoL {
    const message = createBaseServoL();
    message.targetPoseBaseToFlange =
      (object.targetPoseBaseToFlange !== undefined && object.targetPoseBaseToFlange !== null)
        ? Pose.fromPartial(object.targetPoseBaseToFlange)
        : undefined;
    return message;
  },
};

function createBaseSpeedJ(): SpeedJ {
  return { direction: undefined };
}

export const SpeedJ: MessageFns<SpeedJ> = {
  encode(message: SpeedJ, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.direction !== undefined) {
      JointDirection.encode(message.direction, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedJ {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedJ();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.direction = JointDirection.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpeedJ {
    return { direction: isSet(object.direction) ? JointDirection.fromJSON(object.direction) : undefined };
  },

  toJSON(message: SpeedJ): unknown {
    const obj: any = {};
    if (message.direction !== undefined) {
      obj.direction = JointDirection.toJSON(message.direction);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpeedJ>, I>>(base?: I): SpeedJ {
    return SpeedJ.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedJ>, I>>(object: I): SpeedJ {
    const message = createBaseSpeedJ();
    message.direction = (object.direction !== undefined && object.direction !== null)
      ? JointDirection.fromPartial(object.direction)
      : undefined;
    return message;
  },
};

function createBaseFrame(): Frame {
  return { parent: 0, poseInParent: undefined };
}

export const Frame: MessageFns<Frame> = {
  encode(message: Frame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parent !== 0) {
      writer.uint32(8).int32(message.parent);
    }
    if (message.poseInParent !== undefined) {
      Pose.encode(message.poseInParent, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Frame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.parent = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.poseInParent = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Frame {
    return {
      parent: isSet(object.parent) ? builtInFrameFromJSON(object.parent) : 0,
      poseInParent: isSet(object.poseInParent) ? Pose.fromJSON(object.poseInParent) : undefined,
    };
  },

  toJSON(message: Frame): unknown {
    const obj: any = {};
    if (message.parent !== 0) {
      obj.parent = builtInFrameToJSON(message.parent);
    }
    if (message.poseInParent !== undefined) {
      obj.poseInParent = Pose.toJSON(message.poseInParent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Frame>, I>>(base?: I): Frame {
    return Frame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Frame>, I>>(object: I): Frame {
    const message = createBaseFrame();
    message.parent = object.parent ?? 0;
    message.poseInParent = (object.poseInParent !== undefined && object.poseInParent !== null)
      ? Pose.fromPartial(object.poseInParent)
      : undefined;
    return message;
  },
};

function createBaseOrientation(): Orientation {
  return { parent: 0, rotationInParent: undefined };
}

export const Orientation: MessageFns<Orientation> = {
  encode(message: Orientation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parent !== 0) {
      writer.uint32(8).int32(message.parent);
    }
    if (message.rotationInParent !== undefined) {
      Quaternion.encode(message.rotationInParent, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Orientation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrientation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.parent = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rotationInParent = Quaternion.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Orientation {
    return {
      parent: isSet(object.parent) ? builtInFrameFromJSON(object.parent) : 0,
      rotationInParent: isSet(object.rotationInParent) ? Quaternion.fromJSON(object.rotationInParent) : undefined,
    };
  },

  toJSON(message: Orientation): unknown {
    const obj: any = {};
    if (message.parent !== 0) {
      obj.parent = builtInFrameToJSON(message.parent);
    }
    if (message.rotationInParent !== undefined) {
      obj.rotationInParent = Quaternion.toJSON(message.rotationInParent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Orientation>, I>>(base?: I): Orientation {
    return Orientation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Orientation>, I>>(object: I): Orientation {
    const message = createBaseOrientation();
    message.parent = object.parent ?? 0;
    message.rotationInParent = (object.rotationInParent !== undefined && object.rotationInParent !== null)
      ? Quaternion.fromPartial(object.rotationInParent)
      : undefined;
    return message;
  },
};

function createBaseSpeedL(): SpeedL {
  return { direction: undefined, reference: undefined, commandedFrame: undefined, velocityExpressedIn: undefined };
}

export const SpeedL: MessageFns<SpeedL> = {
  encode(message: SpeedL, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.direction !== undefined) {
      CartesianDirection.encode(message.direction, writer.uint32(10).fork()).join();
    }
    if (message.reference !== undefined) {
      Frame.encode(message.reference, writer.uint32(18).fork()).join();
    }
    if (message.commandedFrame !== undefined) {
      Frame.encode(message.commandedFrame, writer.uint32(26).fork()).join();
    }
    if (message.velocityExpressedIn !== undefined) {
      Orientation.encode(message.velocityExpressedIn, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedL {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedL();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.direction = CartesianDirection.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reference = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commandedFrame = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.velocityExpressedIn = Orientation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpeedL {
    return {
      direction: isSet(object.direction) ? CartesianDirection.fromJSON(object.direction) : undefined,
      reference: isSet(object.reference) ? Frame.fromJSON(object.reference) : undefined,
      commandedFrame: isSet(object.commandedFrame) ? Frame.fromJSON(object.commandedFrame) : undefined,
      velocityExpressedIn: isSet(object.velocityExpressedIn)
        ? Orientation.fromJSON(object.velocityExpressedIn)
        : undefined,
    };
  },

  toJSON(message: SpeedL): unknown {
    const obj: any = {};
    if (message.direction !== undefined) {
      obj.direction = CartesianDirection.toJSON(message.direction);
    }
    if (message.reference !== undefined) {
      obj.reference = Frame.toJSON(message.reference);
    }
    if (message.commandedFrame !== undefined) {
      obj.commandedFrame = Frame.toJSON(message.commandedFrame);
    }
    if (message.velocityExpressedIn !== undefined) {
      obj.velocityExpressedIn = Orientation.toJSON(message.velocityExpressedIn);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpeedL>, I>>(base?: I): SpeedL {
    return SpeedL.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedL>, I>>(object: I): SpeedL {
    const message = createBaseSpeedL();
    message.direction = (object.direction !== undefined && object.direction !== null)
      ? CartesianDirection.fromPartial(object.direction)
      : undefined;
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? Frame.fromPartial(object.reference)
      : undefined;
    message.commandedFrame = (object.commandedFrame !== undefined && object.commandedFrame !== null)
      ? Frame.fromPartial(object.commandedFrame)
      : undefined;
    message.velocityExpressedIn = (object.velocityExpressedIn !== undefined && object.velocityExpressedIn !== null)
      ? Orientation.fromPartial(object.velocityExpressedIn)
      : undefined;
    return message;
  },
};

function createBaseExecuteTrajectory(): ExecuteTrajectory {
  return { trajectory: undefined };
}

export const ExecuteTrajectory: MessageFns<ExecuteTrajectory> = {
  encode(message: ExecuteTrajectory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.trajectory !== undefined) {
      JointTrajectory.encode(message.trajectory, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecuteTrajectory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecuteTrajectory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trajectory = JointTrajectory.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExecuteTrajectory {
    return { trajectory: isSet(object.trajectory) ? JointTrajectory.fromJSON(object.trajectory) : undefined };
  },

  toJSON(message: ExecuteTrajectory): unknown {
    const obj: any = {};
    if (message.trajectory !== undefined) {
      obj.trajectory = JointTrajectory.toJSON(message.trajectory);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecuteTrajectory>, I>>(base?: I): ExecuteTrajectory {
    return ExecuteTrajectory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecuteTrajectory>, I>>(object: I): ExecuteTrajectory {
    const message = createBaseExecuteTrajectory();
    message.trajectory = (object.trajectory !== undefined && object.trajectory !== null)
      ? JointTrajectory.fromPartial(object.trajectory)
      : undefined;
    return message;
  },
};

function createBaseWorldToBaseUpdate(): WorldToBaseUpdate {
  return { worldToBase: undefined };
}

export const WorldToBaseUpdate: MessageFns<WorldToBaseUpdate> = {
  encode(message: WorldToBaseUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.worldToBase !== undefined) {
      Pose.encode(message.worldToBase, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldToBaseUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldToBaseUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.worldToBase = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorldToBaseUpdate {
    return { worldToBase: isSet(object.worldToBase) ? Pose.fromJSON(object.worldToBase) : undefined };
  },

  toJSON(message: WorldToBaseUpdate): unknown {
    const obj: any = {};
    if (message.worldToBase !== undefined) {
      obj.worldToBase = Pose.toJSON(message.worldToBase);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldToBaseUpdate>, I>>(base?: I): WorldToBaseUpdate {
    return WorldToBaseUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldToBaseUpdate>, I>>(object: I): WorldToBaseUpdate {
    const message = createBaseWorldToBaseUpdate();
    message.worldToBase = (object.worldToBase !== undefined && object.worldToBase !== null)
      ? Pose.fromPartial(object.worldToBase)
      : undefined;
    return message;
  },
};

function createBaseJointDirection(): JointDirection {
  return { entries: [] };
}

export const JointDirection: MessageFns<JointDirection> = {
  encode(message: JointDirection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.entries) {
      writer.sint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JointDirection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJointDirection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.entries.push(reader.sint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.entries.push(reader.sint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JointDirection {
    return {
      entries: globalThis.Array.isArray(object?.entries) ? object.entries.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: JointDirection): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JointDirection>, I>>(base?: I): JointDirection {
    return JointDirection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JointDirection>, I>>(object: I): JointDirection {
    const message = createBaseJointDirection();
    message.entries = object.entries?.map((e) => e) || [];
    return message;
  },
};

function createBaseCartesianDirection(): CartesianDirection {
  return { linear: [], angular: [] };
}

export const CartesianDirection: MessageFns<CartesianDirection> = {
  encode(message: CartesianDirection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.linear) {
      writer.sint32(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.angular) {
      writer.sint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CartesianDirection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCartesianDirection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.linear.push(reader.sint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.linear.push(reader.sint32());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 16) {
            message.angular.push(reader.sint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.angular.push(reader.sint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CartesianDirection {
    return {
      linear: globalThis.Array.isArray(object?.linear) ? object.linear.map((e: any) => globalThis.Number(e)) : [],
      angular: globalThis.Array.isArray(object?.angular) ? object.angular.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: CartesianDirection): unknown {
    const obj: any = {};
    if (message.linear?.length) {
      obj.linear = message.linear.map((e) => Math.round(e));
    }
    if (message.angular?.length) {
      obj.angular = message.angular.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CartesianDirection>, I>>(base?: I): CartesianDirection {
    return CartesianDirection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CartesianDirection>, I>>(object: I): CartesianDirection {
    const message = createBaseCartesianDirection();
    message.linear = object.linear?.map((e) => e) || [];
    message.angular = object.angular?.map((e) => e) || [];
    return message;
  },
};

function createBasePrimitive(): Primitive {
  return {
    servoJ: undefined,
    servoL: undefined,
    speedJ: undefined,
    speedL: undefined,
    executeTrajectory: undefined,
    worldToBaseUpdate: undefined,
  };
}

export const Primitive: MessageFns<Primitive> = {
  encode(message: Primitive, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.servoJ !== undefined) {
      ServoJ.encode(message.servoJ, writer.uint32(10).fork()).join();
    }
    if (message.servoL !== undefined) {
      ServoL.encode(message.servoL, writer.uint32(18).fork()).join();
    }
    if (message.speedJ !== undefined) {
      SpeedJ.encode(message.speedJ, writer.uint32(26).fork()).join();
    }
    if (message.speedL !== undefined) {
      SpeedL.encode(message.speedL, writer.uint32(34).fork()).join();
    }
    if (message.executeTrajectory !== undefined) {
      ExecuteTrajectory.encode(message.executeTrajectory, writer.uint32(42).fork()).join();
    }
    if (message.worldToBaseUpdate !== undefined) {
      WorldToBaseUpdate.encode(message.worldToBaseUpdate, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Primitive {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrimitive();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.servoJ = ServoJ.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.servoL = ServoL.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.speedJ = SpeedJ.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.speedL = SpeedL.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.executeTrajectory = ExecuteTrajectory.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.worldToBaseUpdate = WorldToBaseUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Primitive {
    return {
      servoJ: isSet(object.servoJ) ? ServoJ.fromJSON(object.servoJ) : undefined,
      servoL: isSet(object.servoL) ? ServoL.fromJSON(object.servoL) : undefined,
      speedJ: isSet(object.speedJ) ? SpeedJ.fromJSON(object.speedJ) : undefined,
      speedL: isSet(object.speedL) ? SpeedL.fromJSON(object.speedL) : undefined,
      executeTrajectory: isSet(object.executeTrajectory)
        ? ExecuteTrajectory.fromJSON(object.executeTrajectory)
        : undefined,
      worldToBaseUpdate: isSet(object.worldToBaseUpdate)
        ? WorldToBaseUpdate.fromJSON(object.worldToBaseUpdate)
        : undefined,
    };
  },

  toJSON(message: Primitive): unknown {
    const obj: any = {};
    if (message.servoJ !== undefined) {
      obj.servoJ = ServoJ.toJSON(message.servoJ);
    }
    if (message.servoL !== undefined) {
      obj.servoL = ServoL.toJSON(message.servoL);
    }
    if (message.speedJ !== undefined) {
      obj.speedJ = SpeedJ.toJSON(message.speedJ);
    }
    if (message.speedL !== undefined) {
      obj.speedL = SpeedL.toJSON(message.speedL);
    }
    if (message.executeTrajectory !== undefined) {
      obj.executeTrajectory = ExecuteTrajectory.toJSON(message.executeTrajectory);
    }
    if (message.worldToBaseUpdate !== undefined) {
      obj.worldToBaseUpdate = WorldToBaseUpdate.toJSON(message.worldToBaseUpdate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Primitive>, I>>(base?: I): Primitive {
    return Primitive.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Primitive>, I>>(object: I): Primitive {
    const message = createBasePrimitive();
    message.servoJ = (object.servoJ !== undefined && object.servoJ !== null)
      ? ServoJ.fromPartial(object.servoJ)
      : undefined;
    message.servoL = (object.servoL !== undefined && object.servoL !== null)
      ? ServoL.fromPartial(object.servoL)
      : undefined;
    message.speedJ = (object.speedJ !== undefined && object.speedJ !== null)
      ? SpeedJ.fromPartial(object.speedJ)
      : undefined;
    message.speedL = (object.speedL !== undefined && object.speedL !== null)
      ? SpeedL.fromPartial(object.speedL)
      : undefined;
    message.executeTrajectory = (object.executeTrajectory !== undefined && object.executeTrajectory !== null)
      ? ExecuteTrajectory.fromPartial(object.executeTrajectory)
      : undefined;
    message.worldToBaseUpdate = (object.worldToBaseUpdate !== undefined && object.worldToBaseUpdate !== null)
      ? WorldToBaseUpdate.fromPartial(object.worldToBaseUpdate)
      : undefined;
    return message;
  },
};

function createBaseEnqueueReply(): EnqueueReply {
  return { accepted: false, primitiveId: undefined, error: undefined };
}

export const EnqueueReply: MessageFns<EnqueueReply> = {
  encode(message: EnqueueReply, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted);
    }
    if (message.primitiveId !== undefined) {
      writer.uint32(16).uint64(message.primitiveId);
    }
    if (message.error !== undefined) {
      writer.uint32(24).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnqueueReply {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnqueueReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accepted = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.primitiveId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnqueueReply {
    return {
      accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false,
      primitiveId: isSet(object.primitiveId) ? globalThis.Number(object.primitiveId) : undefined,
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: EnqueueReply): unknown {
    const obj: any = {};
    if (message.accepted !== false) {
      obj.accepted = message.accepted;
    }
    if (message.primitiveId !== undefined) {
      obj.primitiveId = Math.round(message.primitiveId);
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnqueueReply>, I>>(base?: I): EnqueueReply {
    return EnqueueReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnqueueReply>, I>>(object: I): EnqueueReply {
    const message = createBaseEnqueueReply();
    message.accepted = object.accepted ?? false;
    message.primitiveId = object.primitiveId ?? undefined;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseSafetyLimits(): SafetyLimits {
  return { jointVelocityMax: [], jointAccelerationMax: [], jointTorqueMax: [], tcpLinearVelocityMax: 0 };
}

export const SafetyLimits: MessageFns<SafetyLimits> = {
  encode(message: SafetyLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.jointVelocityMax) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.jointAccelerationMax) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.jointTorqueMax) {
      writer.double(v);
    }
    writer.join();
    if (message.tcpLinearVelocityMax !== 0) {
      writer.uint32(33).double(message.tcpLinearVelocityMax);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SafetyLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSafetyLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.jointVelocityMax.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointVelocityMax.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 17) {
            message.jointAccelerationMax.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointAccelerationMax.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 25) {
            message.jointTorqueMax.push(reader.double());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointTorqueMax.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.tcpLinearVelocityMax = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SafetyLimits {
    return {
      jointVelocityMax: globalThis.Array.isArray(object?.jointVelocityMax)
        ? object.jointVelocityMax.map((e: any) => globalThis.Number(e))
        : [],
      jointAccelerationMax: globalThis.Array.isArray(object?.jointAccelerationMax)
        ? object.jointAccelerationMax.map((e: any) => globalThis.Number(e))
        : [],
      jointTorqueMax: globalThis.Array.isArray(object?.jointTorqueMax)
        ? object.jointTorqueMax.map((e: any) => globalThis.Number(e))
        : [],
      tcpLinearVelocityMax: isSet(object.tcpLinearVelocityMax) ? globalThis.Number(object.tcpLinearVelocityMax) : 0,
    };
  },

  toJSON(message: SafetyLimits): unknown {
    const obj: any = {};
    if (message.jointVelocityMax?.length) {
      obj.jointVelocityMax = message.jointVelocityMax;
    }
    if (message.jointAccelerationMax?.length) {
      obj.jointAccelerationMax = message.jointAccelerationMax;
    }
    if (message.jointTorqueMax?.length) {
      obj.jointTorqueMax = message.jointTorqueMax;
    }
    if (message.tcpLinearVelocityMax !== 0) {
      obj.tcpLinearVelocityMax = message.tcpLinearVelocityMax;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SafetyLimits>, I>>(base?: I): SafetyLimits {
    return SafetyLimits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SafetyLimits>, I>>(object: I): SafetyLimits {
    const message = createBaseSafetyLimits();
    message.jointVelocityMax = object.jointVelocityMax?.map((e) => e) || [];
    message.jointAccelerationMax = object.jointAccelerationMax?.map((e) => e) || [];
    message.jointTorqueMax = object.jointTorqueMax?.map((e) => e) || [];
    message.tcpLinearVelocityMax = object.tcpLinearVelocityMax ?? 0;
    return message;
  },
};

function createBaseSafetySession(): SafetySession {
  return { fullSpeed: undefined, slowSpeed: undefined };
}

export const SafetySession: MessageFns<SafetySession> = {
  encode(message: SafetySession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fullSpeed !== undefined) {
      SafetyLimits.encode(message.fullSpeed, writer.uint32(10).fork()).join();
    }
    if (message.slowSpeed !== undefined) {
      SafetyLimits.encode(message.slowSpeed, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SafetySession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSafetySession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fullSpeed = SafetyLimits.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.slowSpeed = SafetyLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SafetySession {
    return {
      fullSpeed: isSet(object.fullSpeed) ? SafetyLimits.fromJSON(object.fullSpeed) : undefined,
      slowSpeed: isSet(object.slowSpeed) ? SafetyLimits.fromJSON(object.slowSpeed) : undefined,
    };
  },

  toJSON(message: SafetySession): unknown {
    const obj: any = {};
    if (message.fullSpeed !== undefined) {
      obj.fullSpeed = SafetyLimits.toJSON(message.fullSpeed);
    }
    if (message.slowSpeed !== undefined) {
      obj.slowSpeed = SafetyLimits.toJSON(message.slowSpeed);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SafetySession>, I>>(base?: I): SafetySession {
    return SafetySession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SafetySession>, I>>(object: I): SafetySession {
    const message = createBaseSafetySession();
    message.fullSpeed = (object.fullSpeed !== undefined && object.fullSpeed !== null)
      ? SafetyLimits.fromPartial(object.fullSpeed)
      : undefined;
    message.slowSpeed = (object.slowSpeed !== undefined && object.slowSpeed !== null)
      ? SafetyLimits.fromPartial(object.slowSpeed)
      : undefined;
    return message;
  },
};

function createBaseSpeedSlider(): SpeedSlider {
  return { value: 0 };
}

export const SpeedSlider: MessageFns<SpeedSlider> = {
  encode(message: SpeedSlider, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== 0) {
      writer.uint32(9).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedSlider {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedSlider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpeedSlider {
    return { value: isSet(object.value) ? globalThis.Number(object.value) : 0 };
  },

  toJSON(message: SpeedSlider): unknown {
    const obj: any = {};
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpeedSlider>, I>>(base?: I): SpeedSlider {
    return SpeedSlider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedSlider>, I>>(object: I): SpeedSlider {
    const message = createBaseSpeedSlider();
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseSetReply(): SetReply {
  return { accepted: false, error: undefined };
}

export const SetReply: MessageFns<SetReply> = {
  encode(message: SetReply, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted);
    }
    if (message.error !== undefined) {
      writer.uint32(16).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetReply {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accepted = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetReply {
    return {
      accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false,
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: SetReply): unknown {
    const obj: any = {};
    if (message.accepted !== false) {
      obj.accepted = message.accepted;
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetReply>, I>>(base?: I): SetReply {
    return SetReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetReply>, I>>(object: I): SetReply {
    const message = createBaseSetReply();
    message.accepted = object.accepted ?? false;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseControllerStateMsg(): ControllerStateMsg {
  return {
    state: 0,
    activePrimitiveId: undefined,
    activePrimitiveType: undefined,
    queueDepth: 0,
    speedScaling: 0,
    paused: false,
    stepCount: 0,
    errors: [],
  };
}

export const ControllerStateMsg: MessageFns<ControllerStateMsg> = {
  encode(message: ControllerStateMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    if (message.activePrimitiveId !== undefined) {
      writer.uint32(16).uint64(message.activePrimitiveId);
    }
    if (message.activePrimitiveType !== undefined) {
      writer.uint32(26).string(message.activePrimitiveType);
    }
    if (message.queueDepth !== 0) {
      writer.uint32(32).uint32(message.queueDepth);
    }
    if (message.speedScaling !== 0) {
      writer.uint32(45).float(message.speedScaling);
    }
    if (message.paused !== false) {
      writer.uint32(48).bool(message.paused);
    }
    if (message.stepCount !== 0) {
      writer.uint32(56).uint64(message.stepCount);
    }
    writer.uint32(66).fork();
    for (const v of message.errors) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControllerStateMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControllerStateMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.activePrimitiveId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.activePrimitiveType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.queueDepth = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.speedScaling = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.paused = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.stepCount = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.errors.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.errors.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ControllerStateMsg {
    return {
      state: isSet(object.state) ? tCStateFromJSON(object.state) : 0,
      activePrimitiveId: isSet(object.activePrimitiveId) ? globalThis.Number(object.activePrimitiveId) : undefined,
      activePrimitiveType: isSet(object.activePrimitiveType)
        ? globalThis.String(object.activePrimitiveType)
        : undefined,
      queueDepth: isSet(object.queueDepth) ? globalThis.Number(object.queueDepth) : 0,
      speedScaling: isSet(object.speedScaling) ? globalThis.Number(object.speedScaling) : 0,
      paused: isSet(object.paused) ? globalThis.Boolean(object.paused) : false,
      stepCount: isSet(object.stepCount) ? globalThis.Number(object.stepCount) : 0,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => tCErrorCodeFromJSON(e)) : [],
    };
  },

  toJSON(message: ControllerStateMsg): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = tCStateToJSON(message.state);
    }
    if (message.activePrimitiveId !== undefined) {
      obj.activePrimitiveId = Math.round(message.activePrimitiveId);
    }
    if (message.activePrimitiveType !== undefined) {
      obj.activePrimitiveType = message.activePrimitiveType;
    }
    if (message.queueDepth !== 0) {
      obj.queueDepth = Math.round(message.queueDepth);
    }
    if (message.speedScaling !== 0) {
      obj.speedScaling = message.speedScaling;
    }
    if (message.paused !== false) {
      obj.paused = message.paused;
    }
    if (message.stepCount !== 0) {
      obj.stepCount = Math.round(message.stepCount);
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => tCErrorCodeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ControllerStateMsg>, I>>(base?: I): ControllerStateMsg {
    return ControllerStateMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControllerStateMsg>, I>>(object: I): ControllerStateMsg {
    const message = createBaseControllerStateMsg();
    message.state = object.state ?? 0;
    message.activePrimitiveId = object.activePrimitiveId ?? undefined;
    message.activePrimitiveType = object.activePrimitiveType ?? undefined;
    message.queueDepth = object.queueDepth ?? 0;
    message.speedScaling = object.speedScaling ?? 0;
    message.paused = object.paused ?? false;
    message.stepCount = object.stepCount ?? 0;
    message.errors = object.errors?.map((e) => e) || [];
    return message;
  },
};

function createBasePrimitiveEventMsg(): PrimitiveEventMsg {
  return { type: 0, primitiveId: undefined, error: undefined };
}

export const PrimitiveEventMsg: MessageFns<PrimitiveEventMsg> = {
  encode(message: PrimitiveEventMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.primitiveId !== undefined) {
      writer.uint32(16).uint64(message.primitiveId);
    }
    if (message.error !== undefined) {
      writer.uint32(24).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrimitiveEventMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrimitiveEventMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.primitiveId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrimitiveEventMsg {
    return {
      type: isSet(object.type) ? primitiveEventTypeFromJSON(object.type) : 0,
      primitiveId: isSet(object.primitiveId) ? globalThis.Number(object.primitiveId) : undefined,
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: PrimitiveEventMsg): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = primitiveEventTypeToJSON(message.type);
    }
    if (message.primitiveId !== undefined) {
      obj.primitiveId = Math.round(message.primitiveId);
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrimitiveEventMsg>, I>>(base?: I): PrimitiveEventMsg {
    return PrimitiveEventMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrimitiveEventMsg>, I>>(object: I): PrimitiveEventMsg {
    const message = createBasePrimitiveEventMsg();
    message.type = object.type ?? 0;
    message.primitiveId = object.primitiveId ?? undefined;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseServoJTarget(): ServoJTarget {
  return { targetJoints: [] };
}

export const ServoJTarget: MessageFns<ServoJTarget> = {
  encode(message: ServoJTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.targetJoints) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoJTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoJTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.targetJoints.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.targetJoints.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoJTarget {
    return {
      targetJoints: globalThis.Array.isArray(object?.targetJoints)
        ? object.targetJoints.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: ServoJTarget): unknown {
    const obj: any = {};
    if (message.targetJoints?.length) {
      obj.targetJoints = message.targetJoints;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoJTarget>, I>>(base?: I): ServoJTarget {
    return ServoJTarget.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoJTarget>, I>>(object: I): ServoJTarget {
    const message = createBaseServoJTarget();
    message.targetJoints = object.targetJoints?.map((e) => e) || [];
    return message;
  },
};

function createBaseServoLTarget(): ServoLTarget {
  return { targetPoseBaseToFlange: undefined };
}

export const ServoLTarget: MessageFns<ServoLTarget> = {
  encode(message: ServoLTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.targetPoseBaseToFlange !== undefined) {
      Pose.encode(message.targetPoseBaseToFlange, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoLTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoLTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.targetPoseBaseToFlange = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoLTarget {
    return {
      targetPoseBaseToFlange: isSet(object.targetPoseBaseToFlange)
        ? Pose.fromJSON(object.targetPoseBaseToFlange)
        : undefined,
    };
  },

  toJSON(message: ServoLTarget): unknown {
    const obj: any = {};
    if (message.targetPoseBaseToFlange !== undefined) {
      obj.targetPoseBaseToFlange = Pose.toJSON(message.targetPoseBaseToFlange);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoLTarget>, I>>(base?: I): ServoLTarget {
    return ServoLTarget.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoLTarget>, I>>(object: I): ServoLTarget {
    const message = createBaseServoLTarget();
    message.targetPoseBaseToFlange =
      (object.targetPoseBaseToFlange !== undefined && object.targetPoseBaseToFlange !== null)
        ? Pose.fromPartial(object.targetPoseBaseToFlange)
        : undefined;
    return message;
  },
};

/** @language: cpp */
export interface TrajectoryControllerService {
  Enqueue(request: Primitive): Promise<EnqueueReply>;
  SetSafetySession(request: SafetySession): Promise<SetReply>;
  SetSpeedSlider(request: SpeedSlider): Promise<SetReply>;
  Pause(request: Empty): Promise<ControllerStateMsg>;
  Resume(request: Empty): Promise<ControllerStateMsg>;
  ClearQueue(request: Empty): Promise<ControllerStateMsg>;
  Stop(request: Empty): Promise<ControllerStateMsg>;
  FastStop(request: Empty): Promise<ControllerStateMsg>;
  ClearError(request: Empty): Promise<ControllerStateMsg>;
}

export const TrajectoryControllerServiceServiceName = "trajectorycontroller.TrajectoryControllerService";
export class TrajectoryControllerServiceClientImpl implements TrajectoryControllerService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TrajectoryControllerServiceServiceName;
    this.rpc = rpc;
    this.Enqueue = this.Enqueue.bind(this);
    this.SetSafetySession = this.SetSafetySession.bind(this);
    this.SetSpeedSlider = this.SetSpeedSlider.bind(this);
    this.Pause = this.Pause.bind(this);
    this.Resume = this.Resume.bind(this);
    this.ClearQueue = this.ClearQueue.bind(this);
    this.Stop = this.Stop.bind(this);
    this.FastStop = this.FastStop.bind(this);
    this.ClearError = this.ClearError.bind(this);
  }
  Enqueue(request: Primitive): Promise<EnqueueReply> {
    const data = Primitive.encode(request).finish();
    const promise = this.rpc.request(this.service, "Enqueue", data);
    return promise.then((data) => EnqueueReply.decode(new BinaryReader(data)));
  }

  SetSafetySession(request: SafetySession): Promise<SetReply> {
    const data = SafetySession.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetSafetySession", data);
    return promise.then((data) => SetReply.decode(new BinaryReader(data)));
  }

  SetSpeedSlider(request: SpeedSlider): Promise<SetReply> {
    const data = SpeedSlider.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetSpeedSlider", data);
    return promise.then((data) => SetReply.decode(new BinaryReader(data)));
  }

  Pause(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "Pause", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  Resume(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "Resume", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  ClearQueue(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "ClearQueue", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  Stop(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "Stop", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  FastStop(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "FastStop", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  ClearError(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "ClearError", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }
}

/** @language: cpp */
export interface TrajectoryControllerTopics {
  ControllerState(request: ControllerStateMsg): Promise<Empty>;
  PrimitiveEvent(request: PrimitiveEventMsg): Promise<Empty>;
}

export const TrajectoryControllerTopicsServiceName = "trajectorycontroller.TrajectoryControllerTopics";
export class TrajectoryControllerTopicsClientImpl implements TrajectoryControllerTopics {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TrajectoryControllerTopicsServiceName;
    this.rpc = rpc;
    this.ControllerState = this.ControllerState.bind(this);
    this.PrimitiveEvent = this.PrimitiveEvent.bind(this);
  }
  ControllerState(request: ControllerStateMsg): Promise<Empty> {
    const data = ControllerStateMsg.encode(request).finish();
    const promise = this.rpc.request(this.service, "ControllerState", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  PrimitiveEvent(request: PrimitiveEventMsg): Promise<Empty> {
    const data = PrimitiveEventMsg.encode(request).finish();
    const promise = this.rpc.request(this.service, "PrimitiveEvent", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

/** @language: cpp */
export interface TrajectoryControllerSinks {
  WriteServoJ(request: ServoJTarget): Promise<Empty>;
  WriteServoL(request: ServoLTarget): Promise<Empty>;
}

export const TrajectoryControllerSinksServiceName = "trajectorycontroller.TrajectoryControllerSinks";
export class TrajectoryControllerSinksClientImpl implements TrajectoryControllerSinks {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TrajectoryControllerSinksServiceName;
    this.rpc = rpc;
    this.WriteServoJ = this.WriteServoJ.bind(this);
    this.WriteServoL = this.WriteServoL.bind(this);
  }
  WriteServoJ(request: ServoJTarget): Promise<Empty> {
    const data = ServoJTarget.encode(request).finish();
    const promise = this.rpc.request(this.service, "WriteServoJ", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  WriteServoL(request: ServoLTarget): Promise<Empty> {
    const data = ServoLTarget.encode(request).finish();
    const promise = this.rpc.request(this.service, "WriteServoL", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/trajectory_controller_service.proto",
    "package": "trajectorycontroller",
    "dependency": ["google/protobuf/empty.proto", "messenger/geometry.proto", "messenger/joints.proto"],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "CartesianVelocity",
      "field": [{
        "name": "linear",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linear",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "angular",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "angular",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServoJ",
      "field": [{
        "name": "k_p",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "kP",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "command_timeout_ms",
        "number": 2,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandTimeoutMs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ramp_in_duration_ms",
        "number": 3,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rampInDurationMs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServoL",
      "field": [{
        "name": "target_pose_base_to_flange",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "targetPoseBaseToFlange",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SpeedJ",
      "field": [{
        "name": "direction",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.JointDirection",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "direction",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Frame",
      "field": [{
        "name": "parent",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.BuiltInFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "parent",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "pose_in_parent",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poseInParent",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Orientation",
      "field": [{
        "name": "parent",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.BuiltInFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "parent",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rotation_in_parent",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Quaternion",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rotationInParent",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SpeedL",
      "field": [{
        "name": "direction",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.CartesianDirection",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "direction",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reference",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reference",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "commanded_frame",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandedFrame",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity_expressed_in",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Orientation",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocityExpressedIn",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ExecuteTrajectory",
      "field": [{
        "name": "trajectory",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".joints.JointTrajectory",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "trajectory",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "WorldToBaseUpdate",
      "field": [{
        "name": "world_to_base",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "worldToBase",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "JointDirection",
      "field": [{
        "name": "entries",
        "number": 1,
        "label": 3,
        "type": 17,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "entries",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CartesianDirection",
      "field": [{
        "name": "linear",
        "number": 1,
        "label": 3,
        "type": 17,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linear",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "angular",
        "number": 2,
        "label": 3,
        "type": 17,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "angular",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Primitive",
      "field": [{
        "name": "servo_j",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ServoJ",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "servoJ",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "servo_l",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ServoL",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "servoL",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "speed_j",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SpeedJ",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "speedJ",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "speed_l",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SpeedL",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "speedL",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "execute_trajectory",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ExecuteTrajectory",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "executeTrajectory",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "world_to_base_update",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.WorldToBaseUpdate",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "worldToBaseUpdate",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "primitive", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "EnqueueReply",
      "field": [{
        "name": "accepted",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "accepted",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "primitive_id",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "primitiveId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "error",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_primitive_id", "options": undefined }, { "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SafetyLimits",
      "field": [{
        "name": "joint_velocity_max",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointVelocityMax",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joint_acceleration_max",
        "number": 2,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointAccelerationMax",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joint_torque_max",
        "number": 3,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointTorqueMax",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "tcp_linear_velocity_max",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tcpLinearVelocityMax",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SafetySession",
      "field": [{
        "name": "full_speed",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SafetyLimits",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fullSpeed",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "slow_speed",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SafetyLimits",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "slowSpeed",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SpeedSlider",
      "field": [{
        "name": "value",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "value",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetReply",
      "field": [{
        "name": "accepted",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "accepted",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ControllerStateMsg",
      "field": [{
        "name": "state",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCState",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "state",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "active_primitive_id",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "activePrimitiveId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "active_primitive_type",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "activePrimitiveType",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "queue_depth",
        "number": 4,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "queueDepth",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "speed_scaling",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "speedScaling",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "paused",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "paused",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "step_count",
        "number": 7,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "stepCount",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "errors",
        "number": 8,
        "label": 3,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "errors",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_active_primitive_id", "options": undefined }, {
        "name": "_active_primitive_type",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PrimitiveEventMsg",
      "field": [{
        "name": "type",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.PrimitiveEventType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "type",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "primitive_id",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "primitiveId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "error",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_primitive_id", "options": undefined }, { "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServoJTarget",
      "field": [{
        "name": "target_joints",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "targetJoints",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServoLTarget",
      "field": [{
        "name": "target_pose_base_to_flange",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "targetPoseBaseToFlange",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "TCState",
      "value": [
        { "name": "TC_IDLE", "number": 0, "options": undefined },
        { "name": "TC_EXECUTING", "number": 1, "options": undefined },
        { "name": "TC_STOPPING", "number": 2, "options": undefined },
        { "name": "TC_ERROR", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TCErrorCode",
      "value": [
        { "name": "TC_ERROR_NONE", "number": 0, "options": undefined },
        { "name": "TC_ERROR_IN_SINGULARITY", "number": 1, "options": undefined },
        { "name": "TC_ERROR_TRAJECTORY_OVER_LIMITS", "number": 2, "options": undefined },
        { "name": "TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS", "number": 3, "options": undefined },
        { "name": "TC_ERROR_STALENESS_TIMEOUT", "number": 4, "options": undefined },
        { "name": "TC_ERROR_INVALID_TRAJECTORY", "number": 5, "options": undefined },
        { "name": "TC_ERROR_COMPUTATION", "number": 6, "options": undefined },
        { "name": "TC_ERROR_WORKSPACE_LIMIT_VIOLATION", "number": 7, "options": undefined },
        { "name": "TC_ERROR_OVERRUN", "number": 8, "options": undefined },
        { "name": "TC_ERROR_QUEUE_FULL", "number": 9, "options": undefined },
        { "name": "TC_ERROR_NO_CONTROL", "number": 10, "options": undefined },
        { "name": "TC_ERROR_NOT_READY", "number": 11, "options": undefined },
        { "name": "TC_ERROR_NOT_IDLE", "number": 12, "options": undefined },
        { "name": "TC_ERROR_INVALID_ARGUMENT", "number": 13, "options": undefined },
        { "name": "TC_ERROR_FRAME_NOT_SPECIFIED", "number": 14, "options": undefined },
        { "name": "TC_ERROR_FRAME_NOT_SUPPORTED", "number": 15, "options": undefined },
        { "name": "TC_ERROR_INCOMPATIBLE_FRAMES", "number": 16, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PrimitiveEventType",
      "value": [
        { "name": "PRIMITIVE_EVENT_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "PRIMITIVE_STARTED", "number": 1, "options": undefined },
        { "name": "PRIMITIVE_COMPLETE", "number": 2, "options": undefined },
        { "name": "PRIMITIVE_STOPPED", "number": 3, "options": undefined },
        { "name": "PRIMITIVE_FAILED", "number": 4, "options": undefined },
        { "name": "PRIMITIVE_QUEUE_CLEARED", "number": 5, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "BuiltInFrame",
      "value": [
        { "name": "BUILT_IN_FRAME_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "BUILT_IN_FRAME_WORLD", "number": 1, "options": undefined },
        { "name": "BUILT_IN_FRAME_BASE", "number": 2, "options": undefined },
        { "name": "BUILT_IN_FRAME_FLANGE", "number": 3, "options": undefined },
        { "name": "BUILT_IN_FRAME_CAMERA", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "TrajectoryControllerService",
      "method": [{
        "name": "Enqueue",
        "inputType": ".trajectorycontroller.Primitive",
        "outputType": ".trajectorycontroller.EnqueueReply",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetSafetySession",
        "inputType": ".trajectorycontroller.SafetySession",
        "outputType": ".trajectorycontroller.SetReply",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetSpeedSlider",
        "inputType": ".trajectorycontroller.SpeedSlider",
        "outputType": ".trajectorycontroller.SetReply",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Pause",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Resume",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ClearQueue",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Stop",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "FastStop",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ClearError",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "TrajectoryControllerTopics",
      "method": [{
        "name": "ControllerState",
        "inputType": ".trajectorycontroller.ControllerStateMsg",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "PrimitiveEvent",
        "inputType": ".trajectorycontroller.PrimitiveEventMsg",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "TrajectoryControllerSinks",
      "method": [{
        "name": "WriteServoJ",
        "inputType": ".trajectorycontroller.ServoJTarget",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "WriteServoL",
        "inputType": ".trajectorycontroller.ServoLTarget",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/trajectorycontroller",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [5, 1, 2, 12],
        "span": [30, 2, 25],
        "leadingComments": "",
        "trailingComments": " setter rejected because TC not IDLE\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 13],
        "span": [31, 2, 33],
        "leadingComments": "",
        "trailingComments": " out-of-range / wrong length / NaN\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 14],
        "span": [33, 2, 36],
        "leadingComments": " SpeedL frame-slot validation (commanded_frame / reference / velocity_expressed_in).\n",
        "trailingComments": " a required frame/orientation slot was left unset\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 15],
        "span": [34, 2, 36],
        "leadingComments": "",
        "trailingComments": " parent frame not supported (e.g. CAMERA commanded_frame,\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 16],
        "span": [36, 2, 37, 9],
        "leadingComments": " FLANGE velocity axes)\n",
        "trailingComments": " reference and commanded_frame on the same side (not actuatable)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 1],
        "span": [42, 2, 24],
        "leadingComments": "",
        "trailingComments": " Primitive began executing.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 2],
        "span": [43, 2, 25],
        "leadingComments": "",
        "trailingComments": " Primitive finished naturally (isComplete() returned true).\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 3],
        "span": [44, 2, 24],
        "leadingComments": "",
        "trailingComments": " Primitive was interrupted by Stop/FastStop before completing.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 4],
        "span": [45, 2, 23],
        "leadingComments": "",
        "trailingComments": " Primitive encountered an error (see error field).\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 5],
        "span": [46, 2, 30],
        "leadingComments": "",
        "trailingComments": " ClearQueue was called; pending primitives were discarded.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0],
        "span": [64, 0, 67, 1],
        "leadingComments":
          " Linear and angular velocity in the robot base frame.\n Linear: meters/second.  Angular: radians/second.\n\n Not currently referenced by any primitive; kept for a future\n Cartesian-velocity wire surface (e.g. status broadcast). Do not delete.\n",
        "trailingComments": "",
        "leadingDetachedComments": [" --- Messages ---\n"],
      }, {
        "path": [4, 1],
        "span": [73, 0, 77, 1],
        "leadingComments":
          " Starts a position-streaming joint jog. Carries the stream settings and no\n joint target: targets are supplied exclusively through\n WriteServoJ(ServoJTarget), and the arm holds its commanded position until\n the first one arrives.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 0],
        "span": [74, 2, 17],
        "leadingComments": "",
        "trailingComments": " First-order LPF gain on the streamed target.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 1],
        "span": [75, 2, 32],
        "leadingComments": "",
        "trailingComments": " Staleness window before the stream is considered stale.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 2],
        "span": [76, 2, 33],
        "leadingComments": "",
        "trailingComments": " Smooth-start ramp from commanded position to the stream.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2, 2, 0],
        "span": [80, 2, 47],
        "leadingComments": "",
        "trailingComments": " Target pose of the flange in the base frame.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3],
        "span": [87, 0, 89, 1],
        "leadingComments":
          " Direction-only joint jog — speed at TC comes from snapshotted\n JogConfig × slider × active SafetyLimits, composed at enqueue time.\n Requires SetSafetySession and SetSpeedSlider to have been pushed at\n least once before this primitive will be accepted.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4],
        "span": [97, 0, 101, 1],
        "leadingComments":
          " A built-in reference frame plus a rigid offset expressed in that frame.\n Used for SpeedL's `reference` and `commanded_frame` slots; the frame in world\n coordinates is world_to_parent · pose_in_parent.\n\n The offset is REQUIRED: an unset slot (default zero quaternion) is rejected\n with TC_ERROR_FRAME_NOT_SPECIFIED, never treated as identity.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4, 2, 1],
        "span": [99, 2, 100, 8],
        "leadingComments": "",
        "trailingComments": " rigid offset (position + orientation) of this frame, in `parent` coordinates\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [107, 0, 110, 1],
        "leadingComments":
          " A built-in reference frame plus a rotation-only offset expressed in that\n frame. Used for SpeedL's `velocity_expressed_in` slot: it selects the axes\n the CartesianDirection is applied along, so only orientation is meaningful\n (no translation). Same required / fail-loud contract as Frame.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 1],
        "span": [109, 2, 45],
        "leadingComments": "",
        "trailingComments": " rotation of this frame relative to `parent`\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6],
        "span": [126, 0, 131, 1],
        "leadingComments":
          " Cartesian jog. `direction` is a one-hot ±1 axis; the TC sets the\n linear/angular speed from snapshotted JogConfig × slider × SafetyLimits.\n Same SetSafetySession + SetSpeedSlider prerequisites as SpeedJ.\n\n All three frame slots are REQUIRED (unset → TC_ERROR_FRAME_NOT_SPECIFIED),\n per-command and snapshotted at enqueue:\n   * reference:             frame the motion is actuated relative to; parent must\n                            be world-side (WORLD/BASE). Same side as commanded_frame\n                            → TC_ERROR_INCOMPATIBLE_FRAMES.\n   * commanded_frame:       the controlled point (flange→TCP offset) — origin of the\n                            rotational-jog pivot and where the TCP-linear limit binds.\n                            parent must be FLANGE; CAMERA → TC_ERROR_FRAME_NOT_SUPPORTED.\n   * velocity_expressed_in: rotation-only frame selecting the axes `direction` is\n                            applied along (WORLD/BASE, identity rotation).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 9, 2, 0],
        "span": [146, 2, 30],
        "leadingComments": "",
        "trailingComments": " length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 0],
        "span": [150, 2, 29],
        "leadingComments": "",
        "trailingComments": " length 3\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 1],
        "span": [151, 2, 30],
        "leadingComments": "",
        "trailingComments": " length 3\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11, 2, 5],
        "span": [161, 4, 162, 10],
        "leadingComments": "",
        "trailingComments": " sequenced settings command, not a motion primitive\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 0],
        "span": [173, 2, 41],
        "leadingComments": "",
        "trailingComments": " rad/s, length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 1],
        "span": [174, 2, 45],
        "leadingComments": "",
        "trailingComments": " rad/s², length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 2],
        "span": [175, 2, 39],
        "leadingComments": "",
        "trailingComments": " Nm, length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 3],
        "span": [176, 2, 37],
        "leadingComments": "",
        "trailingComments": " m/s\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 15, 2, 0],
        "span": [185, 2, 19],
        "leadingComments": "",
        "trailingComments": " [0, 1]\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 19, 2, 0],
        "span": [211, 2, 36],
        "leadingComments": "",
        "trailingComments": " Joint positions in radians.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 20, 2, 0],
        "span": [215, 2, 47],
        "leadingComments": "",
        "trailingComments": " Target pose of the flange in the base frame.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 0],
        "span": [221, 0, 231, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [" --- Services ---\n"],
      }, {
        "path": [6, 1],
        "span": [234, 0, 237, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 2],
        "span": [240, 0, 243, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".trajectorycontroller.TCState": TCState,
    ".trajectorycontroller.TCErrorCode": TCErrorCode,
    ".trajectorycontroller.PrimitiveEventType": PrimitiveEventType,
    ".trajectorycontroller.BuiltInFrame": BuiltInFrame,
    ".trajectorycontroller.CartesianVelocity": CartesianVelocity,
    ".trajectorycontroller.ServoJ": ServoJ,
    ".trajectorycontroller.ServoL": ServoL,
    ".trajectorycontroller.SpeedJ": SpeedJ,
    ".trajectorycontroller.Frame": Frame,
    ".trajectorycontroller.Orientation": Orientation,
    ".trajectorycontroller.SpeedL": SpeedL,
    ".trajectorycontroller.ExecuteTrajectory": ExecuteTrajectory,
    ".trajectorycontroller.WorldToBaseUpdate": WorldToBaseUpdate,
    ".trajectorycontroller.JointDirection": JointDirection,
    ".trajectorycontroller.CartesianDirection": CartesianDirection,
    ".trajectorycontroller.Primitive": Primitive,
    ".trajectorycontroller.EnqueueReply": EnqueueReply,
    ".trajectorycontroller.SafetyLimits": SafetyLimits,
    ".trajectorycontroller.SafetySession": SafetySession,
    ".trajectorycontroller.SpeedSlider": SpeedSlider,
    ".trajectorycontroller.SetReply": SetReply,
    ".trajectorycontroller.ControllerStateMsg": ControllerStateMsg,
    ".trajectorycontroller.PrimitiveEventMsg": PrimitiveEventMsg,
    ".trajectorycontroller.ServoJTarget": ServoJTarget,
    ".trajectorycontroller.ServoLTarget": ServoLTarget,
    ".trajectorycontroller.TrajectoryControllerService": TrajectoryControllerServiceClientImpl,
    ".trajectorycontroller.TrajectoryControllerTopics": TrajectoryControllerTopicsClientImpl,
    ".trajectorycontroller.TrajectoryControllerSinks": TrajectoryControllerSinksClientImpl,
  },
  dependencies: [protoMetadata1, protoMetadata2, protoMetadata3],
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
